document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-upsell-add]");
  if (!btn) return;

  e.preventDefault();
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
  })
    .then(() => {
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
    })
    .catch(console.error)
    .finally(() => (btn.disabled = false));
});


fetch(`${window.Shopify.routes.root}cart.js`)
  .then(res => res.json())
  .then(cart => {
    if (!cart.items.length) {
      document.querySelectorAll(".m-cart-upsell").forEach(el => {
        el.style.display = "none";
      });
    }
  });
